import React, { useEffect } from 'react';
import { FileText } from 'lucide-react';

const LegalNotice: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <section className="bg-gradient-to-br from-primary-dark via-primary to-accent py-16">
        <div className="container mx-auto px-4 text-center text-white">
          <FileText className="w-16 h-16 mx-auto mb-4" />
          <h1 className="text-5xl font-extrabold mb-4 drop-shadow-2xl">Aviso Legal</h1>
          <p className="text-xl font-light drop-shadow-lg">Última actualización: 19 de octubre de 2025</p>
        </div>
      </section>

      <section className="py-12">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="bg-white p-8 md:p-12 rounded-2xl shadow-lg">
            <div className="prose prose-lg max-w-none
              [&>h2]:text-2xl [&>h2]:font-bold [&>h2]:text-primary [&>h2]:mt-8 [&>h2]:mb-4 [&>h2]:pb-2 [&>h2]:border-b-2 [&>h2]:border-accent/30
              [&>p]:text-gray-700 [&>p]:leading-relaxed [&>p]:mb-4
              [&>ul]:list-disc [&>ul]:list-inside [&>ul]:space-y-2 [&>ul]:mb-4 [&>ul]:text-gray-700
              [&>ul>li]:ml-4">
              <p>Este sitio web (https://trabajofuera.com) es titularidad de Trabajo Fuera Ltd, y su punto de contacto principal es Hamish Jefford.</p>

              <h2>1. Identificación y datos de contacto</h2>
              <ul>
                <li>Titular: Trabajo Fuera Ltd</li>
                <li>Company Number: 16724382</li>
                <li>Domicilio social: 8 Pinfold Court, Chester, UK, CH4 7ES</li>
                <li>Correo electrónico: info@trabajofuera.com</li>
                <li>Teléfono: +34 678 601 100</li>
                <li>Sitio web: https://trabajofuera.com</li>
              </ul>

              <h2>2. Objeto</h2>
              <p>El presente Aviso legal regula el acceso y uso del sitio web trabajofuera.com, así como los contenidos y servicios que se ponen a disposición de las personas usuarias.</p>

              <h2>3. Condición de usuario y normas de uso</h2>
              <p>El acceso o la utilización del sitio atribuye la condición de persona usuaria e implica la aceptación de este Aviso legal, la Política de privacidad y los Términos y condiciones. La persona usuaria se compromete a hacer un uso diligente, correcto y lícito del sitio y sus contenidos.</p>

              <h2>4. Propiedad intelectual e industrial</h2>
              <p>Salvo indicación expresa, los contenidos del sitio (textos, imágenes, logotipos, estructura y diseño) son titularidad de Trabajo Fuera Ltd o de terceros que han autorizado su uso. Queda prohibida su reproducción, distribución o comunicación pública sin autorización previa y por escrito.</p>

              <h2>5. Enlaces</h2>
              <p>El sitio puede contener enlaces a sitios de terceros. Trabajo Fuera Ltd no controla ni responde del contenido, disponibilidad o políticas de dichos sitios. El uso de enlaces externos será bajo responsabilidad de la persona usuaria.</p>

              <h2>6. Responsabilidad</h2>
              <p>Aunque Trabajo Fuera Ltd adopta medidas razonables para mantener la información actualizada y exacta, no garantiza la ausencia de errores ni la disponibilidad continua del sitio. Trabajo Fuera Ltd no responde de daños derivados de interrupciones, virus u otros elementos lesivos, ni del uso ilícito que terceras personas puedan hacer de sus sistemas.</p>

              <h2>7. Accesibilidad</h2>
              <p>Nos comprometemos, dentro de nuestras posibilidades, a mejorar la accesibilidad y la experiencia de todas las personas usuarias. Si detecta barreras de accesibilidad, puede escribirnos a info@trabajofuera.com.</p>

              <h2>8. Protección de datos</h2>
              <p>Los datos personales que se recaben a través del sitio se tratarán conforme a la Política de privacidad vigente.</p>

              <h2>9. Ley aplicable y jurisdicción</h2>
              <p>Salvo que la normativa imperativa disponga otra cosa, este Aviso legal se rige por la legislación del Reino Unido y, en caso de disputa, las partes se someten a los tribunales de Inglaterra y Gales.</p>

              <h2>10. Contacto</h2>
              <p>Para cualquier duda o incidencia relativa a este Aviso legal, escriba a info@trabajofuera.com (a la atención de Hamish Jefford).</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LegalNotice;
